module.exports = "<s-thesaurus-term-select-field :id=\"id\" v-bind=\"$attrs\" v-if=\"id\" />\n"